<script>
import feather from 'feather-icons';

const hasIcon = (name) =>
	Object.prototype.hasOwnProperty.call(feather.icons, name);

export default {
	name: 'FeatherIcon',
	inheritAttrs: false,
	props: {
		name: {
			type: String,
			required: true,
			validator: hasIcon,
		},
	},
	computed: {
		icon() {
			return hasIcon(this.name) ? feather.icons[this.name] : null;
		},
		svgContent() {
			if (!this.icon) return '';

			const svg = this.icon.toSvg();
			const content = svg.match(/^<svg[^>]*>([\s\S]*)<\/svg>$/);
			return content ? content[1] : '';
		},
	},
	created() {
		if (this.icon || process.env.NODE_ENV === 'production') return;

		console.warn(`[FeatherIcon] Unknown icon: "${this.name}"`);
	},
};
</script>

<template>
	<svg
		v-if="icon"
		v-bind="$attrs"
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		stroke-width="2"
		stroke-linecap="round"
		stroke-linejoin="round"
		aria-hidden="true"
		focusable="false"
		v-html="svgContent"
	></svg>
</template>
